import { useState, type CSSProperties } from 'react'
import type { Offer } from '@sp/shared'

/**
 * Obrazek akce v ramecku s pevnou vyskou. U Blixu je imageUrl cela stranka
 * letaku a imageCrop obdelnik nabidky — ukaze se jen vyrez, i s podminkami
 * akce (2+1, jen s kartou), ktere v datech nejsou. Stranku sdili vsechny
 * nabidky na ni, prohlizec ji stahne jednou.
 */
export function OfferImage({ offer, size }: { offer: Offer; size: 'thumb' | 'card' | 'sheet' }) {
  // Obrazek, ktery se nenacte (marktguru u casti akci vraci 404), nema nechat prazdny ramecek.
  const [failed, setFailed] = useState<string | null>(null)
  if (!offer.imageUrl || failed === offer.imageUrl) return null
  const src = offer.imageUrl
  const onError = () => setFailed(src)
  const crop = offer.imageCrop
  if (!crop) {
    return (
      <span className={`offer-pic offer-pic-${size}`}>
        <img className="offer-pic-img" src={src} alt="" loading="lazy" onError={onError} />
      </span>
    )
  }
  const w = crop.x1 - crop.x0
  const h = crop.y1 - crop.y0
  const box = { '--crop-ratio': String((w * crop.ratio) / h) } as CSSProperties
  return (
    <span className={`offer-pic offer-pic-${size}`}>
      <span className="offer-crop" style={box}>
        <img
          src={src}
          alt=""
          loading="lazy"
          onError={onError}
          style={{ width: `${100 / w}%`, left: `${(-crop.x0 / w) * 100}%`, top: `${(-crop.y0 / h) * 100}%` }}
        />
      </span>
    </span>
  )
}
